import { 
  auth, db 
} from "./firebaseConfig";
import { 
  doc, setDoc, getDoc, serverTimestamp 
} from "firebase/firestore";
import { 
  createUserWithEmailAndPassword, signInWithEmailAndPassword, 
  GoogleAuthProvider, signInWithPopup, sendPasswordResetEmail, updatePassword 
} from "firebase/auth";

/**
 * Build a human-readable custom ID:  e.g. "JO-1768679274913"
 * Takes first char of firstName and first char of lastName (uppercase),
 * then appends a hyphen and the current timestamp in milliseconds.
 */
const generateCustomId = (firstName = "", lastName = "") => {
  const f = (firstName.trim()[0] || "U").toUpperCase();
  const l = (lastName.trim()[0] || "U").toUpperCase();
  return `${f}${l}-${Date.now()}`;
};

// Create a new user with email and password
export const doCreateUserWithEmailAndPassword = async (email, password, firstName = "", lastName = "") => {
  const userCredential = await createUserWithEmailAndPassword(auth, email, password);
  const { user } = userCredential;

  const customId = generateCustomId(firstName, lastName);
  const fullName = `${firstName} ${lastName}`.trim() || "New User";

  // Add user to Firestore
  await setDoc(doc(db, "users", user.uid), {
      displayName: fullName,
      firstName: firstName.trim(),
      lastName: lastName.trim(),
      customId,
      email: user.email,
      phoneNumber: "",
      profilePic: "",
      role: "user",
      createdAt: serverTimestamp(),
      wallet: {
          balance: 0,
          currency: "NGN",
          updatedAt: serverTimestamp()
      }
  }, { merge: true });

  return user;
};

// Sign in with Google
export const doSignInWithGoogle = async () => {
  const provider = new GoogleAuthProvider();
  try {
      const result = await signInWithPopup(auth, provider);
      const { displayName, email, photoURL, uid } = result.user;

      const userDocRef = doc(db, "users", uid);
      const userDocSnap = await getDoc(userDocRef);

      if (!userDocSnap.exists()) {
          // Derive initials from Google display name
          const parts = (displayName || "Google User").trim().split(" ");
          const firstName = parts[0] || "G";
          const lastName = parts[parts.length > 1 ? parts.length - 1 : 0] || "U";
          const customId = generateCustomId(firstName, lastName);

          await setDoc(userDocRef, {
              displayName: displayName || "Google User",
              firstName,
              lastName,
              customId,
              email,
              phoneNumber: "",
              profilePic: photoURL || "",
              role: "user",
              createdAt: serverTimestamp(),
              wallet: {
                  balance: 0,
                  currency: "NGN",
                  updatedAt: serverTimestamp()
              }
          }, { merge: true });
      }

      return result;
  } catch (error) {
      console.error("Error signing in with Google:", error);
      throw error;
  }
};

// Other functions remain the same
export const doSignInWithEmailAndPassword = (email, password) => {
  return signInWithEmailAndPassword(auth, email, password);
};

export const doSignOut = () => {
  return auth.signOut();
};

export const doPasswordReset = (email) => {
  return sendPasswordResetEmail(auth, email);
};

export const doPasswordChange = (password) => {
  return updatePassword(auth.currentUser, password);
};
